import { Link } from "@mui/material";

// Use this component when you want a link to open in a new tab to make sure
//  to include the appropriate rel tags (see https://owasp.org/www-community/attacks/Reverse_Tabnabbing)

interface Props {
  href: string;
  label: string;
}

const LinkNewTab = ({ href, label }: Props) => {
  return (
    <Link href={href} target="_blank" rel="noopener noreferrer" underline="hover">
      {label}
    </Link>
  );
};

export default LinkNewTab;
